import axios from 'axios';
import {
  LOGIN_FAILED,
  LOGIN_SUCCESS,
  TOKEN_CHECK,
  TOKEN_CHECK_FAIL,
  LOGOUT,
  BACKEND_URL,
  RESET_SUCCESS,
  RESET_FAILED,
  GET_USER_DATA_BY_EMAIL,
  SET_LOADING_FALSE,
  SET_LOGOUT_PROVISION,
  BACKEND_URL_2,
  SET_URL_META_DATA,
} from '../../actions/types';
import setAuthToken from '../../util/setAuthToken';
import store from '../../store';
import { listCompany } from '../dashboard/company';
import { listUsersData } from '../dashboard/userManagement';

const resolveUserEmail = () =>
  store.getState().auth.data.email ||
  sessionStorage.getItem('email') ||
  localStorage.getItem('email') ||
  '';

//check token
export const loadUser = () => async (dispatch) => {
  if (localStorage.token) {
    setAuthToken(localStorage.token);
    await axios({
      method: 'POST',
      url: BACKEND_URL + 'access/check-token',
      data: {},
    })
      .then(async (response) => {
        if (response.data.statuscode === 200) {
          
          if (sessionStorage.getItem('document_url_processing')) {
          }
          await setAuthToken(false);
          await setAuthToken(response.data.new_token);
          sessionStorage.setItem('current_user_id', response.data.user_id);
          await dispatch({
            type: TOKEN_CHECK,
            payload: {
              token: response.data.new_token,
              data: sessionStorage.setItem('role', response.data.role),
            },
          });
          sessionStorage.setItem('token', response.data.new_token);
          localStorage.setItem('token', response.data.new_token);
          sessionStorage.setItem('role', response.data.role);
          localStorage.setItem('role', response.data.role);
          if (sessionStorage.getItem('document_url_processing')) {
            await dispatch(
              documentUrl(sessionStorage.getItem('document_url_processing'))
            );
          }
          const email = resolveUserEmail();
          if (email) {
            await dispatch(getUserData(email));
          }
          await dispatch(listCompany());
          await dispatch(listUsersData());
        } else if (response.data.statuscode === 403) {
          await dispatch({ type: SET_LOGOUT_PROVISION });
        } else {
          dispatch({
            type: TOKEN_CHECK_FAIL,
          });
        }
      })
      .catch((error) => {
        dispatch({
          type: TOKEN_CHECK_FAIL,
        });
      });
  } else {
    dispatch({ type: SET_LOADING_FALSE });
    await dispatch({ type: LOGOUT });
  }
};

/// document url decoding api
export const documentUrl = (urlHash) => async (dispatch) => {
  if (sessionStorage.getItem('token') === null) {
    return;
  }
  const body = { meta_data: urlHash };
  const config = {
    'Content-Type': 'application/json',
  };
  await axios({
    method: 'POST',
    url: BACKEND_URL_2 + 'ops/operations/parse-metadata',
    data: body,
    headers: config,
  })
    .then(async (response) => {
      if (response.data.statuscode === 200) {
        if (Object.keys(response.data.meta_data).length > 0) {
          dispatch({
            type: SET_URL_META_DATA,
            payload: response.data.meta_data,
          });
        } else {
          dispatch({
            type: SET_URL_META_DATA,
            payload: {},
          });
        }
      } else if (response.data.statuscode === 403) {
        await dispatch({ type: SET_LOGOUT_PROVISION });
      } else {
      }
    })
    .catch((error) => {});
};
//Login user
export const login = (email, password) => async (dispatch) => {
  const config = {
    'Content-Type': 'application/json',
  };
  const body = { email, password };
  await axios({
    method: 'POST',
    url: BACKEND_URL + 'access/loginapi',
    data: body,
    headers: config,
  })
    .then((response) => {
      if (response.data.statuscode === 200) {
        dispatch({
          type: LOGIN_SUCCESS,
          payload: response.data,
        });
        sessionStorage.setItem('LOGIN_CALL_TOP_CARD', true);
        // dispatch(loadUser());
      } else {
        dispatch({
          type: LOGIN_FAILED,
          payload: response.data,
        });
      }
    })
    .catch((error) => {
      dispatch({
        type: LOGIN_FAILED,
        payload: { message: 'server error' },
      });
    });
};

//LOGOUT
export const logout = () => async (dispatch) => {
  if (sessionStorage.getItem('token') === null) {
    await dispatch({ type: LOGOUT });
    return;
  }
  const body = { email: resolveUserEmail() };
  const config = {
    'Content-Type': 'application/json',
  };
  try {
    await axios({
      method: 'POST',
      url: BACKEND_URL + 'access/logout',
      data: body,
      headers: config,
    }).then(async (response) => {
      if (response.data.statuscode === 403) {
        await dispatch({ type: SET_LOGOUT_PROVISION });
      }
    });
  } catch (error) {
  } finally {
    setAuthToken(false);
    await dispatch({ type: LOGOUT });
    sessionStorage.clear();
    localStorage.clear();
    window.location.href = '/login';
  }
};

//forgot password
export const forgotPassword = (email) => async (dispatch) => {
  const config = {
    'Content-Type': 'application/json',
  };
  const body = { email };
  await axios({
    method: 'POST',
    url: BACKEND_URL + 'access/reset-password',
    data: body,
    headers: config,
  })
    .then((response) => {
      if (response.data.statuscode === 200) {
        dispatch({
          type: RESET_SUCCESS,
          payload: response.data,
        });
      } else {
        dispatch({
          type: RESET_FAILED,
          payload: response.data,
        });
      }
    })
    .catch((error) => {
      dispatch({
        type: RESET_FAILED,
        payload: { message: 'server error' },
      });
    });
};

//reset password
export const resetPassword = (email, otp, new_password) => async (dispatch) => {
  const config = {
    'Content-Type': 'application/json',
  };
  const body = { email, otp, new_password };
  await axios({
    method: 'POST',
    url: BACKEND_URL + 'access/update-password',
    data: body,
    headers: config,
  })
    .then((response) => {
      if (response.data.statuscode === 200) {
        dispatch({
          type: RESET_SUCCESS,
          payload: response.data,
        });
      } else {
        dispatch({
          type: RESET_FAILED,
          payload: response.data,
        });
      }
    })
    .catch((error) => {
      dispatch({
        type: RESET_FAILED,
        payload: { message: 'server error' },
      });
    });
};

//get user data
export const getUserData = (email) => async (dispatch) => {
  const resolvedEmail =
    email || sessionStorage.getItem('email') || localStorage.getItem('email') || '';
  if (!resolvedEmail) {
    return;
  }
  const config = {
    'Content-Type': 'application/json',
  };
  const body = { email: resolvedEmail };
  await axios({
    method: 'POST',
    url: BACKEND_URL + 'access/list-user-byemail',
    data: body,
    headers: config,
  })
    .then(async (response) => {
      if (response.data.statuscode === 200) {
        dispatch({
          type: GET_USER_DATA_BY_EMAIL,
          payload: response.data,
        });
      } else if (response.data.statuscode === 403) {
        await dispatch({ type: SET_LOGOUT_PROVISION });
      } else {
      }
    })
    .catch((error) => {});
};
